(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["implagen-behavior"]) return;
  try {
    
function updateImplagenPrice(){const select=document.querySelector('[data-variant-select]');const price=document.querySelector('[data-product-price]');const quantity=document.getElementById('Quantity');if(!select||!price||!quantity)return;const count=Math.max(1,Number(quantity.value)||1);const amount=Number(select.selectedOptions[0].dataset.priceCents)*count/100;price.textContent=new Intl.NumberFormat(document.documentElement.lang,{style:'currency',currency:price.dataset.currency||'EUR'}).format(amount)}
document.addEventListener('input',event=>{if(event.target.id==='Quantity')updateImplagenPrice()});
document.addEventListener('change',event=>{if(event.target.matches('[data-variant-select]'))queueMicrotask(updateImplagenPrice)});

document.addEventListener('change',event=>{const el=event.target;if(el.matches('[data-language],[data-autosubmit]'))el.form.requestSubmit();if(el.matches('[data-variant-select]')){const option=el.selectedOptions[0];const price=document.querySelector('[data-product-price]');if(price)price.textContent=option.dataset.price;const url=new URL(location.href);url.searchParams.set('variant',el.value);history.replaceState({},'',url)}});
document.addEventListener('click',event=>{const thumb=event.target.closest('[data-gallery-src]');if(thumb){const image=document.getElementById('ProductMainImage');if(image){image.src=thumb.dataset.gallerySrc;image.removeAttribute('srcset');document.querySelectorAll('[data-gallery-src]').forEach(el=>el.classList.toggle('active',el===thumb))}}const choice=event.target.closest('[data-cookie-choice]');if(choice&&window.Shopify?.customerPrivacy){const accepted=choice.dataset.cookieChoice==='all';window.Shopify.customerPrivacy.setTrackingConsent({analytics:accepted,marketing:accepted,preferences:accepted,sale_of_data:false},()=>{document.querySelector('[data-cookie-banner]').hidden=true;try{localStorage.setItem('implagen-cookie-choice',choice.dataset.cookieChoice)}catch{}})}});
function initImplagenPrivacy(){const banner=document.querySelector('[data-cookie-banner]');if(!banner||!window.Shopify?.loadFeatures)return;window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}],error=>{if(error)return;let decided=false;try{decided=!!localStorage.getItem('implagen-cookie-choice')}catch{}if(!decided)banner.hidden=false})}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initImplagenPrivacy);else initImplagenPrivacy();
const subject=new URL(location.href).searchParams.get('product');if(subject){const input=document.getElementById('Contactsubject');if(input)input.value=subject}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["implagen-professional-verification"]) return;
  try {
    
document.querySelector('[data-professional-result]')?.focus();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["implagen-quote"] && !Shopify.designMode) return;
  try {
    
function initializeImplagenQuote(root) {
  if (root.dataset.initialized) return;
  root.dataset.initialized = 'true';
  const storageKey = 'implagen-quote-items-v1';
  const referenceKey = 'implagen-quote-reference-v1';
  const success = root.querySelector('[data-quote-success]');
  if (success) {
    try {
      const reference = sessionStorage.getItem(referenceKey);
      if (reference) {
        const output = success.querySelector('[data-quote-reference-output]');
        output.querySelector('strong').textContent = reference;
        output.hidden = false;
      }
      localStorage.removeItem(storageKey);
      sessionStorage.removeItem(referenceKey);
    } catch {}
    success.focus();
    return;
  }
  const form = root.querySelector('form');
  const lines = root.querySelector('[data-quote-lines]');
  const first = lines.querySelector('[data-quote-line]');
  if (!form || !first) return;
  const template = first.cloneNode(true);
  const maximumLines = 49;
  const fields = [
    ['product', 'QuoteProduct', 'product'], ['pack', 'QuotePack', 'pack size'],
    ['quantity', 'QuotePacks', 'packs'], ['sku-input', 'QuoteSKU', 'SKU'],
    ['pieces-input', 'QuotePieces', 'pieces']
  ];
  const status = root.querySelector('[data-quote-status]');
  const notify = message => { status.textContent = message; };
  const validQuantity = value => Number.isInteger(Number(value)) && Number(value) >= 1 && Number(value) <= 10000;
  const optionFor = (row, handle) => Array.from(row.querySelector('[data-line-product]').options).find(option => option.dataset.handle === handle);
  const variantFor = row => {
    const option = row.querySelector('[data-line-product]').selectedOptions[0];
    try { return JSON.parse(option?.dataset.variants || '[]').find(variant => variant.pack === row.querySelector('[data-line-pack]').value); }
    catch { return undefined; }
  };
  const renumber = () => {
    const rows = Array.from(lines.children);
    rows.forEach((row, index) => {
      const number = index + 1;
      row.querySelector('[data-line-number]').textContent = number;
      fields.forEach(([selector, prefix, name]) => {
        const input = row.querySelector(`[data-line-${selector}]`);
        const label = Array.from(row.querySelectorAll('label')).find(label => label.htmlFor === input.id);
        input.id = prefix + number;
        if (label) label.htmlFor = input.id;
        input.name = `contact[Item ${number} ${name}]`;
      });
      row.querySelector('[data-remove-line]').hidden = rows.length === 1;
    });
    root.querySelector('[data-add-line]').disabled = rows.length >= maximumLines;
  };
  const update = () => {
    const records = [];
    const summary = [];
    let pieces = 0;
    Array.from(lines.children).forEach((row, index) => {
      const product = row.querySelector('[data-line-product]');
      const option = product.selectedOptions[0];
      const variant = variantFor(row);
      const quantity = row.querySelector('[data-line-quantity]').value;
      const pack = row.querySelector('[data-line-pack]').value;
      const total = variant && validQuantity(quantity) ? Number(pack) * Number(quantity) : 0;
      row.querySelector('[data-line-sku]').textContent = variant?.sku || '—';
      row.querySelector('[data-line-sku-input]').value = variant?.sku || '';
      row.querySelector('[data-line-total]').textContent = total;
      row.querySelector('[data-line-pieces-input]').value = total;
      if (variant && option?.dataset.handle && validQuantity(quantity)) {
        pieces += total;
        records.push({ handle: option.dataset.handle, pack, quantity: Number(quantity) });
        summary.push(`${index + 1}. ${option.textContent.trim()} | SKU: ${variant.sku} | ${quantity} × ${pack} = ${total} pcs | ${new URL(option.dataset.url, location.origin).href}`);
      }
    });
    root.querySelector('[data-quote-total]').textContent = pieces;
    root.querySelector('[data-quote-summary]').value = summary.join('\n');
    try { localStorage.setItem(storageKey, JSON.stringify({ updatedAt: Date.now(), items: records })); } catch {}
  };
  const addRow = record => {
    if (lines.children.length >= maximumLines) { notify(root.dataset.limit); return null; }
    const row = template.cloneNode(true);
    const product = row.querySelector('[data-line-product]');
    product.value = '';
    row.querySelector('[data-line-pack]').value = '1';
    row.querySelector('[data-line-quantity]').value = '1';
    if (record) {
      const option = optionFor(row, record.handle);
      if (!option || !['1', '5', '10'].includes(String(record.pack)) || !validQuantity(record.quantity)) return null;
      product.value = option.value;
      row.querySelector('[data-line-pack]').value = String(record.pack);
      row.querySelector('[data-line-quantity]').value = String(record.quantity);
    }
    lines.append(row);
    renumber();
    return row;
  };
  let saved = [];
  try {
    const stored = JSON.parse(localStorage.getItem(storageKey) || 'null');
    if (stored && Date.now() - stored.updatedAt < 7 * 24 * 60 * 60 * 1000 && Array.isArray(stored.items)) saved = stored.items.slice(0, maximumLines);
  } catch {}
  if (saved.length) {
    lines.replaceChildren();
    saved.forEach(addRow);
    if (lines.children.length) notify(root.dataset.restored);
  }
  const url = new URL(location.href);
  const handle = url.searchParams.get('product');
  if (handle) {
    const option = optionFor(template, handle);
    let variants = [];
    try { variants = JSON.parse(option?.dataset.variants || '[]'); } catch {}
    const requestedVariant = url.searchParams.get('variant');
    const variant = requestedVariant ? variants.find(item => item.id === requestedVariant) : variants[0];
    const quantity = url.searchParams.get('quantity') || '1';
    if (option && variant && validQuantity(quantity)) {
      if (lines.children.length === 1 && !lines.firstElementChild.querySelector('[data-line-product]').value) lines.replaceChildren();
      const row = addRow({ handle, pack: variant.pack, quantity });
      if (row) notify(root.dataset.added);
    } else notify(root.dataset.invalid);
    ['product', 'variant', 'quantity'].forEach(key => url.searchParams.delete(key));
    history.replaceState({}, '', url);
  }
  if (!lines.children.length) addRow();
  let reference;
  try { reference = sessionStorage.getItem(referenceKey); } catch {}
  reference ||= `IMP-${new Date().toISOString().slice(0, 10).replaceAll('-', '')}-${globalThis.crypto?.randomUUID?.().slice(0, 8).toUpperCase() || Math.random().toString(36).slice(2, 10).toUpperCase()}`;
  root.querySelector('[data-quote-reference]').value = reference;
  try { sessionStorage.setItem(referenceKey, reference); } catch {}
  root.querySelector('[data-add-line]').hidden = false;
  renumber();
  update();
  root.addEventListener('input', event => { if (event.target.closest('[data-quote-line]')) update(); });
  root.addEventListener('change', event => { if (event.target.closest('[data-quote-line]')) update(); });
  root.addEventListener('click', event => {
    if (event.target.closest('[data-add-line]')) {
      const row = addRow();
      if (row) { row.querySelector('[data-line-product]').focus(); notify(root.dataset.added); update(); }
    }
    const button = event.target.closest('[data-remove-line]');
    if (button && lines.children.length > 1) {
      button.closest('[data-quote-line]').remove();
      renumber(); update(); notify(root.dataset.removed);
      lines.lastElementChild.querySelector('[data-line-product]').focus();
    }
  });
  form.addEventListener('submit', event => {
    update();
    if (Array.from(lines.children).some(row => !variantFor(row) || !validQuantity(row.querySelector('[data-line-quantity]').value))) {
      event.preventDefault(); notify(root.dataset.invalid); return;
    }
    if (!form.reportValidity()) { event.preventDefault(); return; }
    const button = root.querySelector('[data-quote-submit]');
    if (button.disabled) { event.preventDefault(); return; }
    button.disabled = true;
    setTimeout(() => { button.disabled = false; }, 8000);
  });
  window.addEventListener('pageshow', () => { root.querySelector('[data-quote-submit]').disabled = false; });
}
function bootImplagenQuote() { document.querySelectorAll('[data-quote-flow]').forEach(initializeImplagenQuote); }
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bootImplagenQuote); else bootImplagenQuote();
document.addEventListener('shopify:section:load', bootImplagenQuote);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
